import React, {useEffect, useMemo, useRef, useState} from 'react'
import moment from 'moment'
import Push from 'push.js'
import {connect} from 'react-redux'
import styled from 'styled-components'
import {setLanguage} from 'redux-i18n'

// Material UI
import {Button} from '../button/'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputAdornment from '@material-ui/core/InputAdornment/InputAdornment'

// Assets
import {ReactComponent as AvatarIcon} from 'images/icons/avatar.svg'
import {ReactComponent as Config} from 'images/icons/config.svg'
import {ReactComponent as Dashboard} from 'images/icons/dashboard.svg'
import {ReactComponent as Flow} from 'images/icons/flow.svg'
import {ReactComponent as Campaign} from 'images/icons/campaign.svg'
import {ReactComponent as Chats} from 'images/icons/chats.svg'
import {ReactComponent as FilterIcon} from 'images/icons/filter.svg'
import {ReactComponent as Backoffice} from 'images/icons/backoffice_icon.svg'
import {ReactComponent as Logo} from 'images/logo_digitalk.svg'
import {ReactComponent as MenuIcon} from 'images/icons/menu.svg'
//import {ReactComponent as AvatarEmpty} from 'images/avatar-empty.jpg'
import Sound from 'message-alert.wav'
import Sound2 from 'ping-alert2.wav'
import {env} from 'env'


// Styled Components
import Form from '../../styled/form/form'
import ListItem from './listItem'
import {Image} from '../../styled'
import {
    Container,
    ContainerChange,
    DialogContainer,
    DialogContent,
    DialogImage,
    DialogSubtitle,
    List,
    MenuContainer,
    SoftPhone,
    BlockedPage,
    BlockedButton,
    BlockedTitleContainer,
    BlockedTime,
    BlockedTitle, Blur,
} from './styled'
import Notification from './notificaiton'
import Profile from './profile'

// API and Actions
import {
    getConfigList,
    handleMenuChat,
    PROTOCOL_RESET,
    putUserAvailable,
    putUserMe,
    putUserRamalStatus, putUserRamalType,
    selectProtocol, updateConfigUser,
    USER_ME_UPDATE,
    userList,
    userLogout,
    userMe,
    userStatusUpdate,
} from '../../../store/actions'

// Paths
import {pathChannel, pathFilter} from '../../../routes/path'
import classNames from 'classnames'
import IconButton from '@material-ui/core/IconButton'
import {ALLOW_NOTIFICATIONS} from './notificaiton/notify'
import FontSize from '../fontSize'
import {useSpeechSynthesis} from 'react-speech-kit'
import {LogUser} from '../../../utils/socket'
import socket from '../../../api/socket'
import {profile} from 'routes/profile'
// Parts
import {Dialogv2} from '../dialogv2/'
import Scrollbar from '../scrollbar/'

// Theme
import {Theme} from 'components/theme/'
import LogoIcon from 'images/logo-icon.png'
import JoditEditor from 'jodit-react'
import {withSnackbar} from 'notistack'
import {useHistory, useLocation} from 'react-router'
import DashOption from './dashOption'
import MenuItem from "@material-ui/core/MenuItem";

const pathChats = []
pathChannel.map((filter) => pathChats.push(`${filter}`))
pathFilter.map((filter) => pathChats.push(`${filter}`))
pathChannel.map((channel) =>
    pathFilter.map((filter) => pathChats.push(`${channel}/${filter}`)),
)

const RETURN_PAUSE = 'RETURN_PAUSE',
    FINISH_PAUSE = 'FINISH_PAUSE'

let audio = new Audio(env.REACT_APP_API_URL.includes('tracbel') ? `${window.location.origin}${Sound}` : `${window.location.origin}${Sound2}`)

const Menu = (props) => {
    const [time, setTime] = useState({time: null})
    const [sendingPause, setSendingPause] = useState(false)
    const listMenuRef = useRef()
    const SoftPhoneRef = useRef()
    const {speak, voices} = useSpeechSynthesis({})
    const [distribuition, setDistribuition] = useState(null)
    const {auth, user, t, putStatus, getProtocol, allConfig} = props
    const [openProfileDialog, setOpenProfileDialog] = useState(false)
    const [openPauseDialog, setOpenPauseDialog] = useState(false)
    const [openPauseChannelDialog, setOpenPauseChannelDialog] = useState(false)
    const [openAppearanceDialog, setOpenAppearanceDialog] = useState(false)
    const history = useHistory()
    const location = useLocation()
    const [config, setConfig] = useState({
        readonly: false,
        toolbar: true,
        toolbarAdaptive: false,
        language: 'pt_br',
        enableDragAndDropFileToEditor: true,
        buttons: [
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            '|',
            'ul',
            'ol',
            '|',
            'font',
            'fontsize',
            'brush',
            'paragraph',
            '|',
            'image',
            'table',
            'link',
            '|',
            'indent',
            'outdent',
            'left',
            'center',
            'right',
            'justify',
            '|',
            'undo',
            'redo',
            '|',
            'hr',
            'eraser',
            'fullsize',
        ],
        placeholder: t?.Dialog?.profile?.Signature?.messageEditor,
        uploader: {
            insertImageAsBase64URI: true,
            url: 'connector/index.php?action=fileUpload',
        },
        emoji: {
            url: 'connector/index.php?action=emoji',
        },
        showXPathInStatusbar: false,
        showCharsCounter: false,
        /*showWordsCounter: false,*/
        style: {
            color: '#000000',
            backgroundColor: '#FFF',
        },
    })

    const handleTextAreaChange = (newTextAreaValue) => {
        return setSignatureEmail((prevState) => ({
            ...prevState,
            form: {
                ...prevState.form,
                email: {
                    ...prevState.form.email,
                    value: newTextAreaValue,
                },
            },
        }))
    }

    useEffect(() => {
        const changeAuthTokenEvent = (e) => {
            localStorage.setItem('token', e.token)
            props.tokenUpdate(e.token)
            window.location.reload()
        }

        const changePhoneStatusEvent = (e) => {
            props.phoneStatusUpdate(e.status)
        }

        const monitoringEvent = (e) => {
            props.getConfig(['user'])
        }

        const createdTicketEvent = (e) => {
            let permission = localStorage.getItem(ALLOW_NOTIFICATIONS)
            if (permission === 'granted') {
                audio.play()
            }
            if (
                permission === 'granted' &&
                Push.Permission.get() === Push.Permission.GRANTED
            ) {
                Push.create('Digitalk', {
                    body: `Ticket ${e[0].id_seq} criado`,
                    icon: LogoIcon,
                    timeout: 7000,
                    onClick: () => {
                        props.select({id: e.protocol_id})
                        window.focus()
                        this.close()
                    },
                })
            }
        }

        const slaTicketEvent = (e) => {
            let permission = localStorage.getItem(ALLOW_NOTIFICATIONS)
            if (permission === 'granted') {
                audio.play()
            }
            if (
                permission === 'granted' &&
                Push.Permission.get() === Push.Permission.GRANTED
            ) {
                Push.create('Digitalk', {
                    body: `Ticket esta com SLA vencido`,
                    icon: LogoIcon,
                    timeout: 7000,
                    onClick: () => {
                        props.select({id: e.protocol_id})
                        window.focus()
                        this.close()
                    },
                })
            }
        }

        const screenpopEvent = (e) => {
            if (e.protocol_user_id === props.auth.id) {
                const {protocol_status, protocol_support, protocol_id} = e
                const url = ['chats']
                if (protocol_support === 'bot') {
                    url.push('bot')
                    switch (protocol_status) {
                        case 'waiting':
                        case 'awaiting_operator':
                        case 'awaiting_customer':
                            url.push('aberto')
                            break
                        case 'closed':
                            url.push('fechado')
                            break
                        case 'nps':
                            url.push('pesquisa')
                            break
                        case 'flow':
                            url.push('flow')
                            break
                    }
                } else if (protocol_support === 'human') {
                    url.push('humano')
                    switch (protocol_status) {
                        case 'waiting':
                            url.push('fila')
                            break
                        case 'awaiting_operator':
                            url.push('atendimento')
                            break
                        case 'awaiting_customer':
                            url.push('retorno_cliente')
                            break
                        case 'closed':
                            url.push('fechado')
                            break
                        case 'video_voice_queue':
                            url.push('ligacao_fila')
                            break
                        case 'video_voice_run':
                            url.push('ligacao')
                            break
                        case 'nps':
                            url.push('pesquisa')
                            break
                        case 'flow':
                            url.push('flow')
                            break
                        case 'group':
                            url.push('grupo')
                            break
                        case 'livestream':
                            url.push('livestream')
                            break
                    }
                }
                url.push(protocol_id)
                getProtocol({id: protocol_id, is_recording_screen: true})
                history.push(`/${url.join('/')}`)
                //window.reload()
            }
        }

        const updateTicketEvent = (e) => {
            let permission = localStorage.getItem(ALLOW_NOTIFICATIONS)
            if (permission === 'granted') {
                audio.play()
            }
            if (
                permission === 'granted' &&
                Push.Permission.get() === Push.Permission.GRANTED
            ) {
                Push.create('Digitalk', {
                    body: `Ticket ${e[0].id_seq} atualizado`,
                    icon: LogoIcon,
                    timeout: 7000,
                    onClick: () => {
                        props.select({id: e.protocol_id})
                        window.focus()
                        this.close()
                    },
                })
            }
        }

        const updateUser = (e) => {
            props.updateConfigUser(e)
        }
        const myf = async () => {
            await props.me()
            await props.getConfig()
            //props.getDepartment()
            //props.getDistribuition()
            //props.getUserStatus()
            //props.getUsers()

            socket.on('screenpop', screenpopEvent)
            socket.on('list_users_status', updateUser)
            socket.on('change_auth_token', changeAuthTokenEvent)
            socket.on('phone_status', changePhoneStatusEvent)
            socket.on('monitoring', monitoringEvent)
            socket.on('created_ticket', createdTicketEvent)
            socket.on('sla_ticket', slaTicketEvent)
            socket.on('updated_ticket', updateTicketEvent)
            socket.emit('join', `user_${auth.id}`)
            socket.emit('join', `notification_${auth.id}`)
        }
        //setTime({...x, time_finish: moment().add(x.time, 'm')})
        localStorage.setItem(ALLOW_NOTIFICATIONS, Push.Permission.get().toString())

        socket.off('reconnect', myf)
        socket.on('reconnect', myf)
        myf()

        return () => {
            localStorage.setItem(ALLOW_NOTIFICATIONS, 'false')
            socket.off('reconnect', myf)
            socket.off('screenpop', screenpopEvent)
            socket.off('list_users_status', updateUser)
            socket.off('change_auth_token', changeAuthTokenEvent)
            socket.off('phone_status', changePhoneStatusEvent)
            socket.off('monitoring', monitoringEvent)
            socket.off('created_ticket', createdTicketEvent)
            socket.off('sla_ticket', slaTicketEvent)
            socket.off('updated_ticket', updateTicketEvent)
            socket.emit('leave', `user_${auth.id}`)
            socket.emit('leave', `notification_${auth.id}`)
        }
    }, [])

    const [signatureEmail, setSignatureEmail] = useState({
        form: {
            email: {
                value:
                    !auth.email_signature || auth.email_signature === 'null'
                        ? ''
                        : auth.email_signature,
                error: '',
            },
        },
        show: false,
    })

    useEffect(() => {
        if (openProfileDialog) {
            setSignatureEmail((prevState) => ({
                ...prevState,
                form: {
                    email: {
                        value:
                            !auth.email_signature || auth.email_signature === 'null'
                                ? ''
                                : auth.email_signature,
                        error: '',
                    },
                },
            }))
        }
    }, [openProfileDialog])

    useEffect(() => {
        if ((Array.isArray(auth.breaks) || Array.isArray(auth.svx_breaks)) && (auth.status === 'pause' || auth.status === 'prebreak')) {
            const breaks = []
            Array.isArray(auth.svx_breaks) && breaks.push(...auth.svx_breaks)
            Array.isArray(auth.breaks) && breaks.push(...auth.breaks)

            let currPause = breaks.find((x) => x.prefix_id === auth.id_break)
            if (auth.status === 'prebreak') {
                setTime({
                    ...currPause,
                    isPreBreak: true,
                })
            } else {
                if (auth.last_request && auth.pause_started_in)
                    setTime({
                        ...currPause,
                        isSVX: (!Array.isArray(auth.breaks) || !auth.breaks.find((x) => x.prefix_id === auth.id_break)),
                        time_finish: moment().add(
                            moment.duration(
                                moment(auth.last_request).diff(
                                    moment(auth.pause_started_in).add(currPause?.time ?? (currPause.minDuration ?? 0), 'm'),
                                ) * -1,
                            ),
                        ),
                    })
            }
        }
    }, [auth.breaks, auth.svx_breaks, auth.status])

    useEffect(() => {
        if (auth.language) {
            props.changeLanguage(auth.language)
        }
    }, [auth.language])

    useEffect(() => {
        if (auth.distribuition) {
            setDistribuition(auth.distribuition)
        }
    }, [auth.distribuition])

    /*useEffect(() => {
          if (!auth.distribuition) {
              props.getAvailable(auth.id)
          }
      }, [auth])*/

    const changeLng = (lng) => {
        props.changeMe({
            ...user.find((user) => user.id === auth.id),
            language: lng,
            theme: auth.theme,
        })
    }

    const calculateTimeLeft = () => {
        let timeLeft = {}
        const {time_finish} = time
        const diff =
            moment.isMoment(time_finish) &&
            moment.duration(time_finish.diff(moment()))
        if (moment.isMoment(time_finish)) {
            timeLeft = {
                Horas: diff.hours(),
                Minutos: diff.minutes(),
                Segundos: diff.seconds(),
            }
        }
        return timeLeft
    }
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

    /*useEffect(() => {
          const timeEvt = setTimeout(() => setTimeLeft(calculateTimeLeft()), 1000)
          if (!time) {
              clearTimeout(timeEvt)
          }
      })*/
    useEffect(() => {
        if (props.auth.status !== 'pause') return
        const intervalId = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000)
        return () => clearInterval(intervalId)
    }, [time, timeLeft.Horas, timeLeft.Minutos, timeLeft.Segundos])
    useEffect(() => {
        if (time.type === RETURN_PAUSE || time.type === FINISH_PAUSE) {
            auth.status = 'online'
        }
    }, [time])

    const changeChannelAvailable = (department_id, channel_id) => {
        let editDistribuition = distribuition.role.departments.map(x => x.department_id === department_id ? ({
            ...x,
            channel: x.channel.map(y => (y.channel_id === channel_id) ? ({...y, availability: !y.availability}) : y),
        }) : x)

        setDistribuition({
            ...auth.distribuition,
            role: {...auth.distribuition.role, departments: editDistribuition},
        })
    }

    const saveChannelAvailable = () => {
        props.putAvailable(auth.id, {...user.find(user => user.id === auth.id), distribuition})
        setOpenPauseChannelDialog(false)
    }

    const isPath = (path) => {
        let pathSplit = location.pathname.split('/').filter(x => x.length > 0)
        return Array.isArray(pathSplit) && pathSplit.length > 0 && pathSplit[0] === path
    }

    useEffect(() => {
        LogUser({
            auth: auth,
            action: 'change_page',
            description: 'User change page in Menu',
            page: location.pathname,
        })
    }, [location.pathname])

    useEffect(() => {
        if (listMenuRef) {
            const {menuSwitcher} = window

            function onMenuItemClick() {
                menuSwitcher.checked = false
            }

            if (listMenuRef?.current?.children) {
                for (const child of listMenuRef.current.children) {
                    child.addEventListener('click', onMenuItemClick)
                }
            }
            return () => {
                if (listMenuRef?.current?.children) {
                    for (const child of listMenuRef.current.children) {
                        child.removeEventListener('click', onMenuItemClick)
                    }
                }
            }
        }
    }, [listMenuRef])

    const [updatePwd, setUpdatePwd] = useState({
        newPwd: '',
        confirmPwd: '',
        error: '',
        showPwd: false,
        changePwd: false,
    })


    const handleChangeDialog = () => {
        setUpdatePwd(prevState => ({
            ...prevState,
            changePwd: !prevState.changePwd,
        }))
    }

    const handleChangeAssignEmail = () => {

    }

    const handleChangeInput = ({target}) => {
        setUpdatePwd(prevState => ({
            ...prevState,
            [target.name]: target.value,
        }))

    }

    const handleSubmitChangePwd = (e) => {
        e.preventDefault()
        //newPwd !== '' && confirmPwd !== '' && newPwd === confirmPwd ? chamar action 'first_login' : setUpdatePwd({error: 'As senhas não são iguais"})
    }


    useEffect(() => {
        if (auth.svx) {
            SoftPhoneRef.current.contentWindow.postMessage({
                source: 'svx-connect-softphone',
                data: {username: auth.svx_username, ...auth.svx},
            }, '*')
        }
    }, [auth.svx])

    const handleShowPassword = () => {
        setUpdatePwd(prevState => ({
            ...prevState,
            showPwd: !prevState.showPwd,
        }))
    }

    const handleRoleLabel = role => {
        if (role === 99) return t.Dialog.profile.role.administrator
        if (role === 5) return t.Dialog.profile.role.monitor
        else return t.Dialog.profile.role.operator
    }

    const handleChangeRamalStatus = e => {
        const {enqueueSnackbar} = props
        props.ramalStatusUpdate({
            id: auth.id,
            ramal_status: e.target.value,
        }, enqueueSnackbar)
    }

    const handleChangeRamalType = () => {
        const {enqueueSnackbar} = props
        props.ramalTypeUpdate({
            id: auth.id,
            ramal_type: auth.ramal_type === 'desktop' ? 'mobile' : 'desktop',
        }, enqueueSnackbar)
    }

    const handleSaveSignatureEmail = () => {
        props.changeMe({
            ...user.find(user => user.id === auth.id),
            email_signature: signatureEmail.form.email.value,
        })
        setSignatureEmail(prevState => ({...prevState, show: false}))
    }

    // let status = user && user.find(x => x.id === auth.id) && user.find(x => x.id === auth.id).status
    const late = Object.keys(timeLeft).length > 0 && Object.keys(timeLeft).map(i => timeLeft[i] <= 0).filter(i => !i).length > 0

    const {newPwd, confirmPwd, error, showPwd, changePwd} = updatePwd

    let voice = (voices.filter(x => x.lang === 'pt-BR' && !x.localService).length > 0 && voices.filter(x => x.lang === 'pt-BR' && !x.localService)[0]) || null
    let department = auth.department.filter(x => x.actived)
    let active = department.map(x => x.id)

    const editorComponent = useMemo(() => {
        return <JoditEditor
            config={config}
            value={signatureEmail.form.email.value}
            placeholder={t?.Dialog?.profile?.Signature?.messageEditor}
            onBlur={handleTextAreaChange}/>
    }, [config, signatureEmail.form.email])

    return (
        <>
            <Container>
                <Logo style={{marginLeft: '24px', maxHeight: '35px'}}/>
                <MenuContainer>

                    <input type='checkbox' id={'menuSwitcher'}/>
                    <div className='menu-container'>
                        {/*className='onlyIcon'*/}
                        <List ref={listMenuRef}>
                            {/*{(profile[auth.role].dashboard) &&
							<ListItem to='/' active={location.pathname === '/'}>
								<Dashboard />
								<p>{t.dashboard}</p>
							</ListItem>}*/}
                            {(profile[auth.role].dashboard) && <DashOption t={t} active={location.pathname === '/'}/>}
                            {(profile[auth.role].chat) && <ListItem to='/chats/humano/atendimento' onClick={() => {
                                props.resetProtocol()
                            }} active={isPath('chats')}>
                                <Chats/>
                                <p>{t.chat}</p>
                            </ListItem>}

                            {(profile[auth.role].workflow) && <ListItem to='/workflow' active={isPath('workflow')}>
                                <Backoffice/>
                                <p>{t.backoffice}</p>
                            </ListItem>}

                            {(profile[auth.role].crm) &&
                                <ListItem to='/crm' active={isPath('crm') || isPath('arquivo')}>
                                    <Campaign/>
                                    <p>{t.crm}</p>
                                </ListItem>}
                            {(profile[auth.role].customer) && <ListItem to='/customers' active={isPath('customers')}>
                                <AvatarIcon/>
                                <p>{t.customers}</p>
                            </ListItem>}
                            {(profile[auth.role].flow) && <ListItem to='/flow' active={isPath('flow')}>
                                <Flow/>
                                <p>{t.smartFlow}</p>
                            </ListItem>}
                            {(profile[auth.role].config) &&
                                <ListItem to='/configuracoes' active={isPath('configuracoes')}>
                                    <Config/>
                                    <p>{t.setting}</p>
                                </ListItem>}
                        </List>

                        <Notification/>

                        <Profile
                            t={t.Profile}
                            available={(!auth.distribuition || (auth.distribuition && auth.distribuition.role.departments.filter(x => active.includes(x.department_id)).map((x) => x.channel.filter(y => y.availability).length > 0).filter(x => !!x).length > 0))}
                            breaks={Array.isArray(auth.svx_breaks) ? [...auth.breaks, ...auth.svx_breaks] : auth.breaks}
                            auth={auth}
                            logout={() => {
                                props.logout()
                                history.push('/login')
                            }}
                            handleOpenProfileDialog={bool => setOpenProfileDialog(bool)}
                            handleOpenAppearanceDialog={bool => setOpenAppearanceDialog(bool)}
                            handleOpenPauseDialog={bool => setOpenPauseDialog(bool)}
                            handleOpenPauseChannelDialog={bool => setOpenPauseChannelDialog(bool)}/>
                    </div>

                    {isPath('chats') && <label htmlFor='filterSwitcher'>
                        <FilterIcon/>
                    </label>}

                    <label htmlFor='menuSwitcher'>
                        <MenuIcon/>
                    </label>
                </MenuContainer>
            </Container>
            {(Object.keys(timeLeft).length > 0 || time.isPreBreak) && <BlockedPage className={classNames({
                not_blocked: !time.lockscreen,
            })}>
                <Blur/>
                <BlockedTitleContainer>
                    {time.isPreBreak ? <BlockedTitle>Pré pausa ativa</BlockedTitle> :
                        <BlockedTitle>{time.description ?? time.name} {late ? 'acaba em:' : <>{!time.isSVX || time.minDuration ? 'excedido em' : ''}:</>}</BlockedTitle>}
                </BlockedTitleContainer>
                <BlockedTime>{Object.keys(timeLeft).map(i =>
                    <>{Math.abs(timeLeft[i]) <= 9 ? `0${Math.abs(timeLeft[i])}` : Math.abs(timeLeft[i])}<span>{i}</span></>)}</BlockedTime>
                <BlockedButton>
                    {!late ? <Button variant='outlined' color='inherit' onClick={() => {
                        putStatus({pause_id: time.id, id_user: auth.id, note: '', action: 'return'})
                        setTime({type: FINISH_PAUSE, time: null})
                    }}>Sair da pausa</Button> : (
                        ((typeof time.obligatory === 'boolean' && !time.obligatory) || !time.minDuration && time.time) && (
                            <Button variant='outlined' color='inherit'
                                    disabled={sendingPause}
                                    onClick={() => {
                                        setSendingPause(prevState => {
                                            if (prevState) {
                                                return prevState
                                            }
                                            setSendingPause(true)
                                            putStatus({pause_id: time.id, id_user: auth.id, note: '', action: 'return'})
                                            setTime({type: RETURN_PAUSE, time: null})
                                            setTimeout(() => setSendingPause(false), 300)
                                        })
                                    }}>Retornar</Button>))}
                </BlockedButton>
            </BlockedPage>}
            {auth?.svx && <SoftPhone allow="microphone 'src'" ref={SoftPhoneRef}
                                     src='https://ads-svx-agf-front-new-liveagent.prod.svx.stefanini.io/'
                                     title='Softphone necxt'/>}
            <Dialogv2 isOpen={openPauseDialog} title={t.Dialog.pause.title}
                      handleClose={bool => setOpenPauseDialog(bool)}>
                <DialogContainer pause>
                    {Array.isArray(auth.breaks) && auth.breaks.map((x) => x.activated &&
                        <Button disabled={sendingPause} key={x.id} onClick={() => {
                            setSendingPause(prevState => {
                                if (prevState) {
                                    return prevState
                                } else {
                                    setSendingPause(true)

                                    putStatus({
                                        pause_id: `DIGI:${x.id}`,
                                        id_user: auth.id,
                                        note: '',
                                        action: 'pause'
                                    }, () => {
                                        setTime({
                                            ...x,
                                            isSVX: false,
                                            id: `DIGI:${x.id}`,
                                            time_finish: moment().add(x.time, 'm'),
                                        })
                                        auth.status = 'pause'
                                        if (auth.ramal && !auth.svx && auth.weon_ramal?.length === 0) {
                                            handleChangeRamalStatus({target: {value: 'logout'}})
                                        }
                                        setOpenPauseDialog(false)
                                        setTimeout(() => setSendingPause(false), 300)
                                    }, (err) => {
                                        props.enqueueSnackbar(`${err}`, {variant: 'error', resumeHideDuration: 5000})
                                        setSendingPause(false)
                                    })

                                }
                            })
                        }}>{x.description}</Button>)}

                    {Array.isArray(auth.svx_breaks) && auth.svx_breaks.length > 0 && <>
                        {auth.svx_breaks.map((x) =>
                            <Button disabled={sendingPause} key={x.id} onClick={() => {
                                setSendingPause(prevState => {
                                    if (prevState) {
                                        return prevState
                                    } else {
                                        setSendingPause(true)

                                        putStatus({
                                            pause_id: `SVX:${x.id}`,
                                            id_user: auth.id,
                                            note: '',
                                            action: 'pause'
                                        }, () => {
                                            setTime({
                                                ...x,
                                                id: `SVX:${x.id}`,
                                                isSVX: true,
                                                time_finish: moment().add(x.minDuration ?? 0, 'm'),
                                            })
                                            auth.status = 'pause'
                                            if (auth.ramal && !auth.svx && auth.weon_ramal?.length === 0) {
                                                handleChangeRamalStatus({target: {value: 'logout'}})
                                            }
                                            setOpenPauseDialog(false)
                                            setTimeout(() => setSendingPause(false), 300)
                                        }, (err) => {
                                            props.enqueueSnackbar(`${err}`, {
                                                variant: 'error',
                                                resumeHideDuration: 5000,
                                            })
                                            setSendingPause(false)
                                        })
                                    }
                                })
                            }}>SVX - {x.name}</Button>)}
                    </>}
                </DialogContainer>
            </Dialogv2>

            <Dialogv2 title='Disponibilidade' isOpen={openPauseChannelDialog}
                      handleClose={bool => setOpenPauseChannelDialog(bool)}>
                {(auth?.ramal_status) && <>
                    <DialogSubtitle>
                        Selecionar status do discador
                    </DialogSubtitle>
                    <FormControl variant='outlined' style={{
                        margin: '6px 0 12px',
                        width: '100%',
                    }}>
                        <Select
                            native
                            value={auth.ramal_status}
                            labelWidth='0'
                            onChange={handleChangeRamalStatus}
                        >
                            {!auth?.svx && <option value='on_call'>Em ligação</option>}
                            <option value='available'>Disponível</option>
                            <option value='logout'>Deslogado</option>
                        </Select>
                    </FormControl>
                </>}

                <Button onClick={handleChangeRamalType}>Alterar
                    para {auth.ramal_type === 'desktop' ? 'celular' : 'PC'}</Button>
                {/*<DialogSubtitle>
					Selecione abaixo o(s) departamento(s) ou canal(is) que deseja ficar disponivel para atendimento
				</DialogSubtitle>
				<DialogContainer distribuition={true}>
					{distribuition && distribuition.role.departments.filter(x => active.includes(x.department_id)).map((x) =>
						<div key={`dept${x.id}`}>
							{department && department.length > 0 &&
							<h4>{department.find(y => y.id === x.department_id).name}: </h4>}
							<div>
								{x.channel.map(y => {
									return (y.channel_id === 1 || y.channel_id === 2 || y.channel_id === 3 || y.channel_id === 4 || y.channel_id === 5 || y.channel_id === 8) &&
										<p key={`dept${x.id}ch${y.channel_id}`}>
											<span>{channelsData.find(ch => ch.id === y.channel_id).label}</span>: <Switch
											onChange={() => changeChannelAvailable(x.department_id, y.channel_id)}
											checked={y.availability} /></p>
								})}
							</div>
						</div>)}
					<Button color='secondary' onClick={saveChannelAvailable} variant='contained'>Salvar</Button>
				</DialogContainer>*/}
            </Dialogv2>

            <Dialogv2 title={t.Dialog.appearance.title} isOpen={openAppearanceDialog}
                      handleClose={bool => setOpenAppearanceDialog(bool)}>
                <DialogContainer appearance>
                    <h4>{t.Dialog.appearance.fontSize}</h4>
                    <FontSize/>
                    <h4 style={{marginTop: '20px'}}>{t.Dialog.appearance.subtitle}</h4>
                    <Scrollbar container={{width: '100%', height: '240px'}}>
                        {Object.keys(Theme).map(key =>
                            <div
                                key={key}
                                onClick={() => {
                                    props.changeMe({
                                        ...user.find(user => user.id === auth.id),
                                        theme: key,
                                    })
                                }}
                                style={{
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    backgroundColor: Theme[key].background,
                                    display: 'flex',
                                    height: '80px',
                                    padding: '10px',
                                    margin: '20px 0 20px',
                                }}>
                                <h1 style={{color: Theme[key].primary}}>Digi</h1>
                                <h1 style={{color: Theme[key].secondary}}>talk</h1>

                                <div style={{
                                    width: '100px',
                                    height: '40px',
                                    backgroundColor: Theme[key].container.primary.background,
                                    marginLeft: '20px',
                                    paddingLeft: '20px',
                                }}>
                                    <p style={{margin: '0', color: Theme[key].container.primary.text}}>teste</p>
                                    <div style={{
                                        width: '100px',
                                        height: '40px',
                                        backgroundColor: Theme[key].container.secondary.background,
                                        position: 'relative',
                                        marginLeft: 0,
                                        paddingLeft: '20px',
                                    }}>
                                        <p style={{margin: '0', color: Theme[key].container.secondary.text}}>teste</p>
                                    </div>
                                </div>
                            </div>,
                        )}
                    </Scrollbar>
                </DialogContainer>
            </Dialogv2>

            <Dialogv2 title={signatureEmail.show ? t?.Dialog?.profile?.button?.changeSignature : t.Dialog.profile.title}
                      isOpen={openProfileDialog} handleClose={bool => setOpenProfileDialog(bool)} background='primary'>
                <DialogContainer profile>
                    {signatureEmail.show ? <DialogContent>
                        {editorComponent}
                        <div className='content'>
                            <button
                                onClick={() => setSignatureEmail(prevState => ({
                                    ...prevState,
                                    show: false
                                }))}>{t?.Dialog?.profile?.button?.cancel}
                            </button>
                            <button onClick={handleSaveSignatureEmail}>{t?.Dialog?.profile?.button?.save}</button>
                        </div>
                    </DialogContent> : <><DialogImage>
                        <Image size={'10rem'} round src={auth.photo}
                               alt={t.Profile.altPhoto}/>
                    </DialogImage>
                        <DialogContent className='profile'>
                            <div className='content'>
                                <p className='name'>{auth.name}</p>
                            </div>
                            <div className='content'>
                                <p className='role'>{handleRoleLabel(Number(auth.role))}</p>
                            </div>
                            <div className='content'>
                                <p className='email'>{auth.email}</p>
                            </div>
                            <div className='content'>
                                <button disabled>{t.Dialog.profile.button.changePassword}</button>
                                <button
                                    onClick={() => setSignatureEmail(prevState => ({
                                        ...prevState,
                                        show: true,
                                    }))}>{t?.Dialog?.profile?.button?.changeSignature}
                                </button>
                            </div>
                            <div>
                                <Select
                                    value={auth.language}
                                    onChange={({target}) => changeLng(target.value)}>
                                    <MenuItem value='pt-BR'>Pt-BR</MenuItem>
                                    {/*<MenuItem value='en-US'>En-US</MenuItem>*/}
                                    <MenuItem value='es-ES'>Es-ES</MenuItem>
                                    <MenuItem value='es-Ar'>Es-Ar</MenuItem>
                                    <MenuItem value='es-Per'>Es-Per</MenuItem>
                                    <MenuItem value='es-Mex'>Es-Mex</MenuItem>
                                </Select>
                            </div>
                            {/*<div>
                            <button onClick={handleChangeDialog}
                                    disabled>{t.Dialog.profile.button.changePassword}</button>
                            <button onClick={() => props.logout(auth)}>{t.Dialog.profile.button.logout}</button>
                        </div>*/}
                        </DialogContent></>}
                </DialogContainer>
                <ContainerChange title={'Alterar Senha'} className={classNames({current: changePwd})}>
                    <DialogContainer className='password_form'>
                        <DialogContent>
                            <Form onSubmit={handleSubmitChangePwd}>
                                <OutlinedInput
                                    autoComplete='new-password'
                                    id='new_pwd'
                                    name='newPwd'
                                    type={!showPwd ? 'password' : 'text'}
                                    isrequired='true'
                                    placeholder='Nova senha'
                                    value={newPwd}
                                    style={{overflow: 'hidden', background: '#FFF'}}
                                    onChange={handleChangeInput}/>
                                {error !== '' && <p>{error}</p>}

                                <OutlinedInput
                                    autoComplete='confirm-password'
                                    id='confirm_pwd'
                                    name='confirmPwd'
                                    type={!showPwd ? 'password' : 'text'}
                                    isrequired='true'
                                    placeholder='Confirmar senha'
                                    value={confirmPwd}
                                    style={{overflow: 'hidden', background: '#FFF'}}
                                    onChange={handleChangeInput}
                                    endAdornment={
                                        <InputAdornment position='end'>
                                            <IconButton
                                                aria-label='Toggle password visibility'
                                                onClick={handleShowPassword}/>
                                        </InputAdornment>}/>
                                {error !== '' && <p>{error}</p>}
                                <div>
                                    <Button type='submit'>Alterar senha</Button>
                                    <Button onClick={handleChangeDialog}>Cancelar</Button>
                                </div>
                            </Form>
                        </DialogContent>
                    </DialogContainer>
                </ContainerChange>
            </Dialogv2>
        </>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    allConfig: state.config,
    user: state.config.user,
    menuOpen: state.handle.open,
    t: state.i18nState.translations[state.i18nState.lang]['Menu'],
})

const mapDispatchToProps = (dispatch) => ({
    putStatus: (data, onSuccess, onError) => {
        dispatch(userStatusUpdate(data, onSuccess, onError))
    },
    getUsers: () => dispatch(userList()),
    logout: (me) => {
        dispatch(userLogout(me))
    },
    getConfig: (x) => {
        dispatch(getConfigList(x))
    },
    updateConfigUser: (x) => {
        dispatch(updateConfigUser(x))
    },
    getProtocol: (protocol) => dispatch(selectProtocol(protocol)),
    me: () => dispatch(userMe()),
    changeMe: (me) => dispatch(putUserMe(me)),
    putAvailable: (id, data) => dispatch(putUserAvailable(id, data)),
    tokenUpdate: (e) => dispatch({type: USER_ME_UPDATE, token: e}),
    phoneStatusUpdate: (status) => dispatch({type: USER_ME_UPDATE, ramal_status: status}),
    ramalStatusUpdate: (data, snackbar) => dispatch(putUserRamalStatus(data, snackbar)),
    ramalTypeUpdate: (data, snackbar) => dispatch(putUserRamalType(data, snackbar)),
    resetProtocol: () => dispatch({type: PROTOCOL_RESET}),
    openMenu: () => dispatch(handleMenuChat()),
    changeLanguage: (lng) => dispatch(setLanguage(lng)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(Menu))